export function newErrorDecision(key, user, reasons) {
    return {
        variationKey: null,
        enabled: false,
        variables: {},
        ruleKey: null,
        flagKey: key,
        userContext: user,
        reasons: reasons,
    };
}
export const __platforms = ['__universal__'];
//# sourceMappingURL=index.js.map